<ng-container *transloco="let t">
  <div class="page-footer" data-test-id="footer">
    <p>
      <span data-test-id="footer.need-help-txt">{{ t('common.needHelp') }}</span>
      <a [href]="'mailto:' + supportEmail" data-test-id="footer.support-link">
        {{ t('common.contactSupport') }}
      </a>
    </p>
  </div>
</ng-container>
